import randomString from '@/utils/random-string';

interface IconTouchAppGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}

const IconTouchAppGradient = ({ id: _id, size = 16, from = '#5AE4FF', to = '#A7FF7B' }: IconTouchAppGradientProps) => {
  const id = _id || `icon-add-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 17 16" fill="none">
      <path
        d="M7.78398 14.668C7.47287 14.668 7.18121 14.6013 6.90898 14.468C6.63676 14.3346 6.40621 14.1457 6.21732 13.9013L2.58398 9.28464L2.90065 8.9513C3.12287 8.71797 3.38954 8.57908 3.70065 8.53464C4.01176 8.49019 4.30065 8.5513 4.56732 8.71797L5.80065 9.46797V4.0013C5.80065 3.81241 5.86454 3.65408 5.99232 3.5263C6.1201 3.39852 6.27843 3.33464 6.46732 3.33464C6.65621 3.33464 6.81732 3.39852 6.95065 3.5263C7.08398 3.65408 7.15065 3.81241 7.15065 4.0013V7.33464H12.134C12.6895 7.33464 13.1618 7.52908 13.5507 7.91797C13.9395 8.30686 14.134 8.77908 14.134 9.33464V12.0013C14.134 12.7346 13.8729 13.3624 13.3507 13.8846C12.8284 14.4069 12.2007 14.668 11.4673 14.668H7.78398ZM3.58398 5.66797C3.43954 5.42352 3.32843 5.15964 3.25065 4.8763C3.17287 4.59297 3.13398 4.3013 3.13398 4.0013C3.13398 3.07908 3.45898 2.29297 4.10898 1.64297C4.75898 0.992969 5.5451 0.667969 6.46732 0.667969C7.38954 0.667969 8.17565 0.992969 8.82565 1.64297C9.47565 2.29297 9.80065 3.07908 9.80065 4.0013C9.80065 4.3013 9.76176 4.59297 9.68398 4.8763C9.60621 5.15964 9.4951 5.42352 9.35065 5.66797L8.20065 5.0013C8.28954 4.84575 8.35621 4.68741 8.40065 4.5263C8.4451 4.36519 8.46732 4.19019 8.46732 4.0013C8.46732 3.44575 8.27287 2.97352 7.88398 2.58464C7.4951 2.19575 7.02287 2.0013 6.46732 2.0013C5.91176 2.0013 5.43954 2.19575 5.05065 2.58464C4.66176 2.97352 4.46732 3.44575 4.46732 4.0013C4.46732 4.19019 4.48954 4.36519 4.53398 4.5263C4.57843 4.68741 4.6451 4.84575 4.73398 5.0013L3.58398 5.66797Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="2.58398" y1="7.66797" x2="14.134" y2="7.66797" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconTouchAppGradient;
